"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.payCheckoutPath = exports.payCheckout = void 0;
const utils_1 = require("@invivodf/utils");
const utils_2 = require("../../../utils");
const payCheckout = (client) => async ({ checkoutId, payment }) => {
    try {
        const response = await client.post((0, exports.payCheckoutPath)(checkoutId), payment);
        return utils_1.Result.success(response.data);
    }
    catch (error) {
        if ((0, utils_2.isFunctionalApiError)(error)) {
            return utils_1.Result.failure({
                code: error.body.code,
                message: error.body.message
            });
        }
        throw error;
    }
};
exports.payCheckout = payCheckout;
const payCheckoutPath = (checkoutId) => `/v2/bff/appro/checkouts/${checkoutId}/pay`;
exports.payCheckoutPath = payCheckoutPath;
